import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TableWrapper: {
    position: 'relative'
  },
  ApplyFilterWrapper: {
    marginTop: theme.spacing(4),
    textAlign: 'right'
  },
  ActivateButton: {
    padding: theme.spacing(0)
  },
  UserCustomMenu: {
    '& a, & button': {
      padding: theme.spacing(0.75, 1),
      width: '100%',
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(16),
      justifyContent: 'flex-start'
    }
  },
  dateChip: {
    display: 'flex',
    '& time': {
      marginLeft: theme.spacing(1)
    }
  },
  FilterChip: {
    display: 'flex',
    '& span': {
      marginLeft: theme.spacing(1)
    }
  }
}))
